var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransitionAsset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "transitionAsset",
    viewBox: "0 0 1745.35 319.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#4834d4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TransitionAsset",
    "data-name": "TransitionAsset"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transition"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,0S91.56,142.46,401.61,115.18s265.64,25,476,25S1124.64,197,1327,206.13s418.35,113.68,418.35,113.68H0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransitionAsset);
export default __webpack_public_path__ + "static/media/Transition Asset.f0fe93c667a094cca4d05f6a8d1dff8a.svg";
export { ForwardRef as ReactComponent };